module.exports = __webpack_public_path__ + "img/course-card.eab07c33.png";